import { useContext, useEffect } from 'react'
import { initialPaymentState } from './usePaymentState'
import { DataContext } from '../../../context/DataContext'
import { GETNET } from '../../../constants/payment'

export const usePaymentEffects = ({
  userToken,
  paymentState,
  setPaymentState,
  paymentActions
}) => {
  const { userInfo, currentStep } = useContext(DataContext)
  const { checkIfCustomerHasSavedCards, getCustomerCardsData } = paymentActions
  const { names, email } = userInfo
  const { gateway } = paymentState

  const resetPaymentState = () => {
    userToken.current = null
    setPaymentState(initialPaymentState)
  }

  const setForceNewPayment = () => {
    setPaymentState((prevState) => ({
      ...prevState,
      forceNewPayment: true
    }))
  }

  const resetInstallmentsIfNotCredit = (selectedPaymentOption) => {
    if (selectedPaymentOption !== 'credit') {
      setPaymentState((prevState) => ({
        ...prevState,
        installments: null
      }))
    }
  }

  const resetInstallmentsIfIsGetnet = () => {
    if (gateway === GETNET) {
      setPaymentState((prevState) => ({
        ...prevState,
        installments: null
      }))
    }
  }

  // If the names or email changes, reset the payment state
  useEffect(() => {
    resetPaymentState()
    setForceNewPayment()
  }, [names, email])

  // Use effect to check if the customer has saved cards
  useEffect(() => {
    if (currentStep !== 3 || paymentState.hasSavedCards !== null) return
    checkIfCustomerHasSavedCards()
  }, [currentStep, paymentState.hasSavedCards])

  // Use effect to get the customer cards data
  useEffect(() => {
    if (!paymentState.isUsingSavedCards) {
      return
    }
    getCustomerCardsData()
  }, [paymentState.isUsingSavedCards])

  // Use effect to set installments when the selected payment option changes
  useEffect(() => {
    resetInstallmentsIfNotCredit(paymentState.selectedPaymentOption)
  }, [paymentActions.selectedPaymentOption])

  // Use effect to reset installments when the gateway is GETNET and changes the isSavingCard
  useEffect(() => {
    resetInstallmentsIfIsGetnet()
  }, [paymentState.isSavingCard])
}
